import { requestOptional, requestOptionalUrl, rebindEvent, openKendoWindow, openKendoWindowUrl } from 'scripts/Utilities/core';
import { getResource } from 'scripts/Utilities/resources';
import { getDataItem, getKendoWidget } from 'scripts/Utilities/searchTable';

const updateCartButtons = (sender: JQuery<HTMLElement>, addToCart: boolean) => {
    if (!sender || sender.length < 1) {
        return;
    }

    let svgIcon = sender.find('use');
    let kendoIcon = sender.find('.k-icon');
    const textElement = sender.find(".button-text");

    if (addToCart) {
        sender.addClass('removable').attr("title", getResource("RemoveFromCart"));
        if (svgIcon.length > 0) {
            svgIcon.attr("xlink:href", "/bundles/sprite.svg#icon-minus");
        }
        else if (kendoIcon.length > 0) {
            kendoIcon.removeClass("k-i-plus").addClass("k-i-minus");
        }

        if (textElement.length > 0) {
            textElement.text(getResource("RemoveFromCart"));
        }
    }
    else {
        sender.removeClass('removable').attr("title", getResource("AddToCart"));
        if (svgIcon.length > 0) {
            svgIcon.attr("xlink:href", "/bundles/sprite.svg#icon-plus");
        }
        else if (kendoIcon.length > 0) {
            kendoIcon.removeClass("k-i-minus").addClass("k-i-plus");
        }

        if (textElement.length > 0) {
            textElement.text(getResource("AddToCart"));
        }
    }
}

const resetInfoButtons = () => {
    let infoButtons = $(".object-info .cart-js[data-object].removable")
        .add($(".cart-js[data-hash].removable"));
    infoButtons.each((_, item) => {
        updateCartButtons($(item), false);
    });
}

function bindEvents() {
    rebindEvent(
        'click',
        '.object-option.cart-js',
        (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget);
            let addToCart = !sender.hasClass('removable');
            let kendoWidget = kendo.widgetInstance(sender.closest(".k-listview, .k-grid")) as kendo.ui.ListView | kendo.ui.Grid;
            let object = getObjectByWidget(sender, kendoWidget);
            let sourceKey = sender.data("sourcekey") || (kendoWidget ? kendoWidget.element.data("sourcekey") : null);
            let senderHash = sender.data("hash");
            let hash = senderHash != null ? senderHash : (object ? object["Hash"] : null);
            let data;

            if (sourceKey && hash != null) {
                data = {
                    hashes: [hash],
                    addToCart: addToCart,
                    sourceKey: sourceKey
                };
            }
            else if (object) {
                data = {
                    objects: [object],
                    addToCart: addToCart,
                    intersectKey: kendoWidget ? kendoWidget.element.data("intersectkey") : sender.data("intersectkey")
                };
            }
            else {
                return;
            }

            let success = (cartItems: number) => {
                if (!cartItems && cartItems != 0) {
                    return;
                }

                let infoButtons = $(".object-info .cart-js[data-object]").filter((index, item) => $(item).data("object")["Hash"] == hash)
                    .add($(".cart-js[data-hash]").filter((index, item) => $(item).data("hash") == hash));
                updateCartButtons(sender, addToCart);
                updateCartButtons(infoButtons, addToCart);

                refresh();
                refreshGisGrid();

                var resultListViews = $(".resultsList");
                if (kendoWidget) {
                    resultListViews = resultListViews.not($(kendoWidget.element));
                }

                if (resultListViews.length > 0) {
                    resultListViews.each((index, item) => {
                        let listView = kendo.widgetInstance($(item)) as kendo.ui.ListView;
                        if (listView && listView.dataSource.total() > 0) {
                            listView.dataSource.read();
                        }
                    })
                }
            };

            let url = sender.attr("href");
            if (url) {
                requestOptionalUrl(url, { type: "POST", useArea: false, data: data, success: success });
            }
            else {
                requestOptional("ChangeCartObjects", "Map", { type: "POST", data: data, success: success });
            }
        });
    rebindEvent(
        'click',
        '.clearCart-js',
        (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget);
            let clearSuccess = () => {
                var resultListViews = $(".resultsList").not("#cart");
                if (resultListViews.length > 0) {
                    resultListViews.each((index, item) => {
                        let listView = $(item).data("kendoListView") as kendo.ui.ListView;
                        if (listView && listView.dataSource.total() > 0) {
                            listView.dataSource.read();
                        }
                    })
                }
                refresh((cart) => cart.dataSource.total() > 0);
                refreshGisGrid();
                resetInfoButtons();
            };

            let url = sender.attr("href");
            if (url && url.charAt(0) !== "#") {
                requestOptionalUrl(url, { type: "POST", useArea: false, success: clearSuccess });
            }
            else {
                requestOptional("ClearCartObject", "Map", { type: "POST", success: clearSuccess });
            }
        });
    rebindEvent(
        'click',
        '.js-trigger-mapmenu',
        (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget);
            let mapmenu = sender.parents('.mapmenu');
            mapmenu.toggleClass('opened');

            if (mapmenu.hasClass('opened')) sender.prop('title', getResource("Close"));
            else sender.prop('title', getResource("Open"));

            if (!$('body').hasClass('map')) {
                $(document).on('click', function onMapMenuHide(e) {
                    var targetElement = e.target as any;
                    if (!$('.mapmenu').is(targetElement) && !$('.mapmenu').has(targetElement).length) {
                        $(".mapmenu").removeClass('opened');
                        sender.prop('title', getResource("Open"));
                        $(document).off('click', onMapMenuHide)
                    }
                })
            }
        });
    rebindEvent('click', '.object-list-wrap .object a.label', (e: JQuery.TriggeredEvent) => {
        e.preventDefault();
        let sender = $(e.currentTarget);
        sender.siblings('.object-properties').slideToggle(200).end()
            .parent().toggleClass('active')
            .siblings('.active').children('.object-properties').slideToggle(100).end().removeClass('active');
        let wrapper = sender.closest(".object");
        let descWrapper = wrapper.hasClass("active") ? wrapper.find(".object-properties:first") : null;
        if (descWrapper && !descWrapper.html()) {
            let widget = getKendoWidget(sender as JQuery<HTMLElement>)
            let dataItem = getDataItem(sender as JQuery<HTMLElement>);
            let data = dataItem.toJSON();
            data["query"] = widget.element.data("query");
            if (dataItem) {
                requestOptional(
                    "GetObjectDescription",
                    "Map",
                    {
                        type: "GET",
                        data: data,
                        success: (data) => {
                            if (data) {
                                descWrapper.html(data);
                            }
                        }
                    });
            }
        }
    });
    rebindEvent('click', '.object-option.info-js', (e: JQuery.TriggeredEvent) => {
        e.preventDefault();
        let sender = $(e.currentTarget);
        let listView = sender.closest(".k-listview").data("kendoListView") as kendo.ui.ListView;
        let object = listView ? listView.dataItem(sender.closest(".k-listview-item") as JQuery) : null;
        if (!object) {
            return;
        }

        let json = object.toJSON();
        if (json["Type"] == "8888" && typeof json["Description"] === "string") {
            json["Description"] = json["Description"].split("|")[0] || "";
        }

        openKendoWindow(
            "GetObjectInfo",
            "Map",
            {
                type: "GET",
                data: json
            },
            {
                title: `${getResource("Info")}: ${json["Title"]}`,
                width: 500,
                open: (evt) => {
                    initFloorsDropDown(evt.sender.wrapper);
                }
            },
        );
    });
    rebindEvent('click', '.object-option.lot-info-js', (e: JQuery.TriggeredEvent) => {
        e.preventDefault();
        let sender = $(e.currentTarget);
        let listView = sender.closest(".k-listview").data("kendoListView") as kendo.ui.ListView;
        let object = listView ? listView.dataItem(sender.closest(".k-listview-item") as JQuery) : null;
        if (!object) {
            return;
        }

        let json = object.toJSON();
        openKendoWindow(
            "GetObjectLotInfo",
            "Map",
            {
                type: "GET",
                data: json
            },
            {
                title: `${getResource("LotInfo")}: ${json["Title"]}`,
                width: "40%",
                height: "60%",
                position: {
                    top: 90
                }
            }
        );
    });
}

bindEvents();

export function dataBound(e: kendo.ui.ListViewEvent) {
    const total = e.sender.dataSource.total();
    $(".object-count")
        .text(total.toString())
        .toggle(total > 0);

    const wrapper = e.sender.wrapper.closest(".center");
    const cartElements = wrapper.find(".object-list-wrap, .mapmenu-bottom");
    const noDataHeader = wrapper.find(".header-js");

    if (total < 1) {
        cartElements.hide();
        noDataHeader.show();

    }
    else {
        noDataHeader.hide();
        cartElements.show();

        let cartPager = $("#cartPager").data("kendoPager");
        if (cartPager) {
            cartPager.options.dataSource = e.sender.dataSource;
            cartPager.dataSource = e.sender.dataSource;
            cartPager.refresh();
        }
    }
}

export function refresh(condition: (listView: kendo.ui.ListView) => boolean = () => true) {
    var cart = kendo.widgetInstance($("#cart")) as kendo.ui.ListView;
    if (cart) {
        if (condition(cart)) {
            cart.dataSource.read();
        }

        $(cart.element)[0].dispatchEvent(new Event('refresh', { 'bubbles': true }));
    }

    let elements = $("[name='ServiceObjectHash']");
    if (elements.length > 0) {
        elements.each((index, item) => {
            let serviceObjectHashDropDownList = kendo.widgetInstance($(item)) as kendo.ui.DropDownList;
            if (serviceObjectHashDropDownList) {
                serviceObjectHashDropDownList.dataSource.read();
            }
        });
    }

    var geolocationIds = [
        "#GeoExtentObject",
        "#GeoExtentObjectLargeScaleTopoMap",
        "#GeoExtentObject50",
        "#GeoExtentObject2005",
        "#GeoExtentObjectGmmpGnss",
        "#GeoExtentObjectGmmp",
        "#GeoExtentObjectNivelation3",
        "#GeoExtentObjectNivelation4",
        "#GeoExtentObjectNivelation5",
        "#GeoExtentObjectNivelationGR",
        "#GeoExtentObjectNivelationMAR",
        "#GeoExtentObjectGravimetricPoints",
        "#GeoExtentObjectTideStations",
        "#GeoExtentObjectArchivePlan",
        "#GeoExtentObjectPhotogrammetry",
        "#GeoExtentObjectLandBalance",
        "#GeoExtentObjectTopoMapsheet",
        "#GeoExtentObjectAll",
        "#GeoExtentObjectSpecializedMap",
        "#GeoExtentObjectSpecializedMapToDate"
    ];
    for (let i = 0; i < geolocationIds.length; i++) {
        var targetGeolocation = $(geolocationIds[i]).data("kendoDropDownList") as kendo.ui.DropDownList;
        if (targetGeolocation) {
            targetGeolocation.dataSource.read();
        }
    }
}

export function getObjectByWidget(sender: JQuery, widget: kendo.ui.ListView | kendo.ui.Grid) {
    let object = sender.data("object");
    if (object) {
        return object;
    }

    if (widget) {
        if (widget instanceof kendo.ui.Grid) {
            return widget.dataItem(sender.closest("tr")).toJSON();
        }
        else {
            return widget.dataItem(sender.closest(".k-listview-item")).toJSON();
        }
    }
}

function refreshGisGrid() {
    $(".map-window-js").each(function () {
        let wnd = $(this).data("kendoWindow") as kendo.ui.Window;
        if (!wnd) {
            return;
        }

        wnd.element.find(".k-grid").each(function () {
            let grid = $(this).data("kendoGrid") as kendo.ui.Grid;
            grid?.dataSource.read();
        });
    });
}

function initFloorsDropDown(wrapper: JQuery): void {
    let floorsDropDown = wrapper.find("input.floor-js").data("kendoDropDownList") as kendo.ui.DropDownList;
    if (floorsDropDown) {
        let bind = floorsDropDown.element.data("bind");
        if (bind) {
            floorsDropDown.setDataSource(
                new kendo.data.DataSource({
                    data: bind
                }));
            floorsDropDown.select(0);
        }

        let floorApartmentsListView = wrapper.find(".floorApartments-js:first").data("kendoListView");
        floorsDropDown.bind("change", (e: kendo.ui.DropDownListChangeEvent) => {
            if (floorApartmentsListView) {
                floorApartmentsListView.dataSource.read();
            }
        });
        floorsDropDown.trigger("change");
    }
}
